import ActivityLog from './ActivityLog'

export default function ActivityLogRoute({ match, location }) {
  console.log('ActivityLogRoute rendered', match, location)

  if (match) {
    const params = new URLSearchParams(location.search)
    let start = params.get('start') ? parseInt(params.get('start')) : 1
    const objectTypeId = params.get('objectTypeId')
    const actionUserId = params.get('actionUserId')
    let fromDate = params.get('fromDate')
    if (!fromDate) {
      fromDate = new Date()
      fromDate.setMonth(-1)
      fromDate = fromDate.toISOString().substring(0,10)
    }
    let toDate = params.get('toDate')
    if (!toDate) {
      toDate = new Date()
      toDate = toDate.toISOString().substring(0,10)
    }
    return (
      <ActivityLog key={new Date()} objectTypeId={objectTypeId} actionUserId={actionUserId} fromDate={fromDate} toDate={toDate} location={location} start={start} />
    )
  }
}
